import React, {useContext} from 'react';
import styled from 'styled-components';
import {GalleryContext} from '@volkswagen-onehub/components-core';

const Dot = styled.button<{$active: boolean}>`
  width: ${({$active}) => ($active ? '20px' : '10px')};
  height: ${({$active}) => ($active ? '20px' : '10px')};
  background-color: #00b0f0;
  border-radius: 50%;
  border: 2px solid #ffffff;
  cursor: pointer;
  padding: 0;
  transition:
    width 0.3s ease,
    height 0.3s ease;
`;

const DotsWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  height: 20px;
`;

export const CustomLentils = () => {
  const {index, length, triggerChange} = useContext(GalleryContext);

  return (
    <DotsWrapper>
      {Array.from({length}).map((_, i) => (
        <Dot
          key={i}
          $active={i === index}
          onClick={() => triggerChange(i)}
          aria-label={`carousel slide ${i + 1}`}
          aria-checked={i === index}
          role="radio"
        />
      ))}
    </DotsWrapper>
  );
};
